/**
 * Ruimte-detectie voor de zij-statistieken onder het design-planeetgrid
 * (feedback 2026-08-23): naast de geavanceerde Resonance-LPS passen de
 * statistieken op een Full HD-scherm niet zonder dat de chart-kolom gaat
 * scrollen, op QHD en hoger wél. De pagina meet de geometrie; deze helper
 * neemt de beslissing.
 */

/** Terugvalhoogte (px) van het statistiekenblok zolang het nog nooit gerenderd/gemeten is. */
export const HD_SIDE_STATS_FALLBACK_HEIGHT_PX = 240;

/** Marge tussen grid-paneel en statistiekenblok (`.side-stats-combined { margin-top }`). */
export const HD_SIDE_STATS_GAP_PX = 12;

/** Ademruimte die onder het statistiekenblok moet overblijven vóór de stack-onderrand. */
export const HD_SIDE_STATS_BOTTOM_CLEARANCE_PX = 8;

/** Geometrie van één meting; alle afstanden t.o.v. de bovenkant van de chart-stack. */
export interface HdSideStatsSpaceMeasurement {
  /** Beschikbare (begrensde) hoogte van de chart-stack. */
  readonly stackHeight: number;
  /** Onderrand van het grid-paneel (zónder statistieken). */
  readonly gridPanelBottom: number;
  /** Of het gemeten paneel de Resonance-variant was (de enige waarvoor de vraag telt). */
  readonly resonance: boolean;
}

/**
 * Passen de statistieken onder het gemeten Resonance-paneel? `false` zonder
 * meting of wanneer de meting van de gewone (lagere) grid stamt — dan is er
 * nog geen betrouwbare uitspraak en blijft de oude uitsluiting gelden.
 */
export function sideStatsFitBelowResonanceGrid(
  measurement: HdSideStatsSpaceMeasurement | null,
  statsHeight: number | null,
): boolean {
  if (measurement == null || !measurement.resonance) {
    return false;
  }
  const needed = measurement.gridPanelBottom
    + HD_SIDE_STATS_GAP_PX
    + (statsHeight ?? HD_SIDE_STATS_FALLBACK_HEIGHT_PX)
    + HD_SIDE_STATS_BOTTOM_CLEARANCE_PX;
  return needed <= measurement.stackHeight;
}
